import React from 'react';
import { usePrototype } from '../../contexts/PrototypeContext';
import { useAnchorNavigation } from '../../hooks/useAnchorNavigation';
import { siteConfig } from '../../data/siteConfig';
import { formatPrice } from '../../utils/currency';
export function SeasonBanner() {
  const {
    seasonConfig,
    campaignName,
    showCampaignBanner
  } = usePrototype();
  const goTo = useAnchorNavigation();
  if (!showCampaignBanner) return null;
  return <div role="region" aria-label="Announcement" className={`transition-colors duration-200 ease-out ${seasonConfig.bannerClass}`} data-id="element-464" data-mp="1wzrz2vdh3t5o">
      <p className="mx-auto max-w-page px-5 py-1 text-center text-[13px] leading-snug [overflow-wrap:anywhere] md:px-10" data-id="element-465" data-mp="1na8ixxh5adei">
        {campaignName} · {formatPrice(siteConfig.product.samplePrice)} · {siteConfig.fulfillment.shippingLabel}
        {seasonConfig.bannerLinkLabel && <a href="/#the-mask" onClick={goTo('the-mask')} className="ml-2 inline-flex min-h-[44px] items-center font-medium underline underline-offset-4" data-id="element-466" data-mp="2b0kx3q2zh6dj">
            {seasonConfig.bannerLinkLabel}
          </a>}
      </p>
    </div>;
}